import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getCategorias,
  deleteCategoria,
  changeStatusCategoria,
} from "../../../../api/categoria";
import { Button, Tooltip, Switch, FormControlLabel } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { getNonEmpty } from "../../../../utils/helpers";
import { getCursos } from "../../../../api/curso";
import FullCalendarView from "../../../components/FullCalendarView";
import { getEventos } from "../../../../api/evento";

function getData(cursos) {
  let data = [];
  for (let i = 0; i < cursos.length; ++i) {
    const elem = {};
    elem.titulo = getNonEmpty(cursos[i].titulo);
    elem.fechaIni = cursos[i].fechaIni;
    elem.fechaFin = cursos[i].fechaFin;
    elem.id = cursos[i]._id;
    elem.active = cursos[i].active;
    data = data.concat(elem);
  }
  data.sort((a, b) => a.orden - b.orden);
  return data;
}

const initialFilters = {
  active: false,
};

export default function CalendarioPage() {
  const [data, setData] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [categoriaId, setCategoriaId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refreshOrder, setRefreshOrder] = useState(false);

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resCurso = await getCursos();
        const resEvento = await getEventos();
        if (resCurso.status === 200 && resEvento.status === 200) {
          const lista = [...resCurso.data, ...resEvento.data];
          setData(lista);
          setFilteredData(lista);
          setRefresh(false);
        }
      } catch (error) {
        alertError({
          error: error,
          customMessage: "Could not get categorias.",
        });
      }
    };

    fetchData();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <>
        <br />
        <FormControlLabel
          control={
            <Switch
              checked={filterOptions.active}
              onChange={() =>
                setFilterOptions({
                  ...filterOptions,
                  active: !filterOptions.active,
                })
              }
              name="checkActive"
            />
          }
          label={filterOptions.active ? "Only active" : "All active/inactive"}
        />
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista Categorías">
          {/* <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-categoria")}
            >
              Add new
            </button>
          </CardHeaderToolbar> */}
        </CardHeader>
        <CardBody>
          {/* <FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          /> */}

          <FullCalendarView cursos={getData(data)} />

          <ConfirmDialog
            title={`Are you sure you want to ${
              categoriaId?.active ? "disable" : "enable"
            } this user type?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusCategoria(categoriaId.id, !categoriaId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        categoriaId?.active ? "Disabled!" : "Enabled!"
                      }`,
                      customMessage: `User type ${
                        categoriaId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      categoriaId?.active ? "disable" : "enable"
                    } user type.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this user type?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCategoria(categoriaId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Categoria removed successfully.",
                    });
                    setRefresh(true);
                    setRefreshOrder(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove categoria.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
